import React, { useContext } from 'react';
import {
    Paper,
    Typography,
    FormGroup,
    FormControlLabel,
    Switch,
    useTheme,
} from '@mui/material';
import { ThemeContext } from '../../theme/AppThemeProvider'; // Importe o contexto

const AppearanceSection = () => {
    const theme = useTheme();
    const { toggleColorMode } = useContext(ThemeContext); // Use o contexto

    // Determina se o modo escuro está ativo pelo tema atual
    const isDarkMode = theme.palette.mode === 'dark';

    return (
        <Paper
            sx={{
                p: 2.5,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,
                boxShadow: theme.shadows[2],
            }}
        >
            <Typography
                variant="h6"
                gutterBottom
                sx={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                }}
            >
                Aparência
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isDarkMode}
                            onChange={toggleColorMode} // Chama a função do contexto
                            color="primary"
                        />
                    }
                    label="Tema Escuro"
                />
            </FormGroup>
        </Paper>
    );
};

export default AppearanceSection;
